<template>
  <div
    class="overlay"
    :class="{ visible: menuOpen }"
    @click.self="handleOverlay"
  ></div>
  <div class="drawer" :class="props.from">
    <AcvButton class="tw-lg:!tw-hidden" variant="link" @click="handleClick">
      <img src="/images/dock_to_right.svg?url" alt="left drawer menu icon" />
    </AcvButton>
    <slot name="tooltip"></slot>

    <div class="drawer__menu" :class="{ 'menu-open': menuOpen }">
      <slot></slot>
    </div>
  </div>
</template>
<script setup>
import { useOverlayScrollHelper } from '@/composables/useOverlayScrollHelper';
const { preventBgFromScrolling, allowBgToScroll } = useOverlayScrollHelper();

const props = defineProps({
  menuOpen: {
    type: Boolean,
    default: false,
  },
  from: {
    type: String,
    default: 'left',
  },
});

const emit = defineEmits(['toggleMenu', 'toggleOverlay']);

const handleClick = () => {
  preventBgFromScrolling();
  emit('toggleMenu');
};

const handleOverlay = () => {
  allowBgToScroll();
  emit('toggleOverlay');
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/shared/_constants.scss';
* {
  @apply tw-transition-all
  tw-duration-300;
}

.overlay {
  @apply tw-fixed
      tw-h-full
      tw-w-full
      tw-inset-0
      tw-bg-black-500
      tw-z-10
      tw-transition-all
      tw-duration-300
      tw-z-[-10]
      tw-invisible;
  opacity: 0;

  &.visible {
    @apply tw-z-20
      tw-transition-all
      tw-duration-300
      tw-visible;
    opacity: 1;
  }
}

.drawer {
  @apply tw-bg-white;

  &__menu {
    @apply tw-flex
    tw-flex-col
    tw-min-h-screen
    tw-bg-white
    tw-rounded-2xl
    tw-p-8
    tw-fixed
    tw-top-0
    tw-left-[-300px];
    min-height: 100svh; // if browser doesn't support svh default to vh
    box-shadow: 0px 8px 10px 0px #84848433, 0px 6px 30px 0px #8484841f,
      0px 16px 24px 0px #84848424;

    @media (min-width: $md-min) {
      @apply tw-static
      tw-shadow-none
      tw-min-w-60;
    }

    &.menu-open {
      @apply tw-left-0
      tw-right-20
      tw-overflow-y-scroll
      tw-z-30;
      max-height: 100svh;

      @media (min-width: $sm-min) {
        @apply tw-w-64;
      }
    }
  }

  &.right {
    @apply tw-right-[-50px]
    tw-left-auto;

    @media (min-width: $sm-min) {
      @apply tw-right-0
      tw-left-[95%];
    }

    .drawer__menu {
      @apply tw-right-[-300px]
      tw-left-auto;

      &.menu-open {
        @apply tw-right-0;
      }
    }
  }
}
</style>
